export const repeatLabels = {
  none: "Does not repeat",
  daily: "Every day",
  weekly: "Every week",
  monthly: "Every month",
  yearly: "Every year",
};
export const statusLabels = {
  todo: "To do",
  progress: "In progress",
  done: "Done",
};
export const dateKey = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
export const formatDate = (value) =>
  value
    ? new Date(`${value}T12:00:00`).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "No due date";
export function errorMessage(error) {
  const data = error?.response?.data;
  if (!data) return "Could not save or load this item. Please try again.";
  if (typeof data === "string") return data;
  return Object.entries(data)
    .map(
      ([key, value]) =>
        `${key === "detail" ? "" : key + ": "}${Array.isArray(value) ? value.join(" ") : typeof value === "object" ? JSON.stringify(value) : value}`,
    )
    .join(" ");
}
export const refreshReminders = () =>
  window.dispatchEvent(new Event("planner-updated"));
